import React, { FC } from "react";
import { DynamicImage, DynamicImageSource } from "./DynamicImage";

export type AuthorProps = {
  name: string;
  role: string;
  imageUrl: DynamicImageSource;
  imageAlt: string;
};

export const Author: FC<AuthorProps> = ({ name, role, imageUrl, imageAlt }) => (
  <>
    {(!!imageUrl || !!name) && (
      <div className="flex gap-xs">
        {/* TODO: Bild nedan ska vara helt rund, saknas klass för det nu */}
        {!!imageUrl && (
          <DynamicImage
            src={imageUrl}
            alt={imageAlt}
            className="w-xl h-xl object-cover rounded-full"
          />
        )}

        <div className="flex flex-col gap-xxs">
          <h4 className="text-small font-600 text-secondary-500">{name}</h4>
          <small className="text-stylized uppercase text-secondary-300">{role}</small>
        </div>
      </div>
    )}
  </>
);
